export default {"src":"/_next/static/media/bannerBg.24aaf797.svg","height":178,"width":1440};